@if (expirationDate) {
  <div class="alert d-inline-block p-1"
    [ngClass]="{ 'alert-danger': expired, 'expiring-soon': expiringSoon }">
    {{ expirationDate | date: 'MM/dd/yyyy' }}
  </div>
}
